import React from "react";

const PseudoFirstSection = () => {
  return (
    <div className="pseudo">
      <p className="text1 text">Oops!! Turn on the lights first.</p>
      <p className="text2 text"> Click on the pink button.</p>
    </div>
  );
};

export default PseudoFirstSection;
